import React, {useState} from "react";
import "./topbar.css";
import Button from 'react-bootstrap/Button'
import { NotificationsNone, Language, Settings } from "@material-ui/icons";
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from "@material-ui/core";
import { resolvePath, Navigate } from "react-router-dom";


const useStyles = makeStyles((theme) => {
    return {
        avatar: {
            minHeight: '40px',
            minWidth: '40px',
            marginLeft: theme.spacing(2)
          },
  
    }
  })


  

export default function Topbar() {
    const classes = useStyles()

    const [redir, setRedir] = useState('');

    const handleLogout = async () => {
      localStorage.setItem('token', '');
      }


  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
          <span className="logo">CNSP Web Browser</span>
        </div>

        <div className="topRight">
        <div className="topbarIconContainer">
        <button onClick={handleLogout} ></button>
        {redir && <Navigate to="/login" />}
          </div>
        </div>
      </div>
    </div>
  );
}